import { DASHBOARD_LOJAS_EXCLUIDAS } from '../../shared/lojaOptions';

const formatDateInputValue = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};

const parseDateInputValue = (value) => {
  if (!value) return null;
  const [year, month, day] = String(value).split('-').map(Number);
  const date = new Date(year, (month || 1) - 1, day || 1);

  return Number.isNaN(date.getTime()) ? null : date;
};

export const MAX_TODAS_CARGAS_DAYS = 31;
export const DASHBOARD_FIXED_FILTERS = {
  StatusViagemAngellira: ['Finalizada'],
  LojaExceto: DASHBOARD_LOJAS_EXCLUIDAS
};

const normalizeFilterValue = (value) => {
  if (Array.isArray(value)) {
    return value
      .map((item) => normalizeFilterValue(item))
      .filter((item) => item !== undefined && item !== null && item !== '');
  }

  if (value && typeof value === 'object' && Object.prototype.hasOwnProperty.call(value, 'value')) {
    return value.value;
  }

  return value;
};

export const getDefaultDashboardFilters = () => {
  const finalDate = new Date();
  const initialDate = new Date();
  initialDate.setMonth(initialDate.getMonth() - 1);

  return {
    DataInicial: formatDateInputValue(initialDate),
    DataFinal: formatDateInputValue(finalDate),
    CNPJCliente: ''
  };
};

export const normalizeDashboardFilters = (filters = {}) => {
  const defaults = getDefaultDashboardFilters();
  const dataInicial = filters.DataInicial || defaults.DataInicial;
  const dataFinal = filters.DataFinal || defaults.DataFinal;

  return Object.fromEntries(
    Object.entries({
      ...filters,
      DataInicial: `${dataInicial}T00:00:00`,
      DataFinal: `${dataFinal}T23:59:59`,
      ...DASHBOARD_FIXED_FILTERS
    })
      .map(([key, value]) => [key, normalizeFilterValue(value)])
      .filter(([, value]) => value !== undefined && value !== null && value !== '' && (!Array.isArray(value) || value.length > 0))
  );
};

export const getDashboardFilterDayRange = (filters = {}) => {
  const defaults = getDefaultDashboardFilters();
  const start = parseDateInputValue(filters.DataInicial || defaults.DataInicial);
  const end = parseDateInputValue(filters.DataFinal || defaults.DataFinal);

  if (!start || !end) return null;

  const startDate = new Date(start.getFullYear(), start.getMonth(), start.getDate());
  const endDate = new Date(end.getFullYear(), end.getMonth(), end.getDate());
  const diffMs = endDate.getTime() - startDate.getTime();

  return Math.floor(diffMs / 86400000) + 1;
};

export const isTodasCargasRangeAllowed = (filters = {}) => {
  const range = getDashboardFilterDayRange(filters);
  return range !== null && range > 0 && range <= MAX_TODAS_CARGAS_DAYS;
};
